module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/support.svg?c2c880148ecf7f1646e5599dfe42c118";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/support.svg
// module id = 16
// module chunks = 0